import { FieldSelectOption } from '@app-types/entity_types'
import ActionTypes from '@constants/action_types'

type NormalizedData = { [key: string]: { [id: string]: FieldSelectOption } }

export function fieldSelectOptionDeleted(normalizedData: NormalizedData) {
  return {
    type: ActionTypes.FIELD_SELECT_OPTION_DELETED,
    payload: normalizedData,
  }
}

export default fieldSelectOptionDeleted
